import { Link } from 'react-router-dom';

export const TextLink = ({
  children,
  to,
  ...props
}: { children: React.ReactNode; to: string } & React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <Link {...props} to={to} className={`text-messaging-info-main hover:underline ${props.className || ''}`}>
    {children}
  </Link>
);
